module.exports = __webpack_public_path__ + "static/media/promo.db5b0a39.jpg";